import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const navOverlay = () => {
    let tl;
    tl = gsap.timeline({paused: true});

    tl.addLabel('start');
    tl.to('.nav-overlay', {autoAlpha: 1, ease: "power1.inOut", duration: 0.5, zIndex: 99999999, clipPath: 'circle(0% at 100% 0%)'}, '<0.15');
    tl.to('.nav-overlay', {clipPath: 'circle(150% at 100% 0%)', ease: "power1.inOut", duration: 1}, '<0.1');

    tl.to('.nav-overlay__close', {rotation: 360 * 3, ease: "power1.inOut", duration: 1.5}, '<');

    tl.to('.nav-overlay__logo', {autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", duration: 0.3}, '<0.15');
    tl.to('.nav-overlay #nav-hidden p', {autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", duration: 0.3}, '<0.15');
    tl.fromTo('.nav-overlay #nav-hidden ul li a',
        {autoAlpha: 0, y: 120},
        {autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.3, stagger: 0.05},
        '<0.15');
    tl.to('.nav-overlay #nav-three p', {autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", duration: 0.3}, '<0.15');
    tl.to('.nav-overlay #nav-three nav', {autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", duration: 0.3}, '<0.15');

    document.querySelector('.hamburger').addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.add('menu-open');
        tl.play();
    });

    document.querySelector('.nav-overlay__close').addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.add('menu-open');
        tl.play();
        navCloseHandler();
    });

    function navCloseHandler() {
        document.body.classList.remove('menu-open');
        tl.reverse();
    }

    function handleNavClose() {
        // Remove any existing event listener to prevent multiple bindings
        document.querySelector('.nav-overlay__close').removeEventListener('click', navCloseHandler);

        // Check if the screen width is above 1024 pixels
        if (window.innerWidth > 1024) {
            navCloseHandler();
        }
    }

    // Attach the resize event listener
    window.addEventListener('resize', handleNavClose);

    // Initial check when the page loads
    handleNavClose();
};

navOverlay();